<template lang="pug">
div
  q-card-section.q-gutter-md
    .text-h6.row.justify-between
      .col-auto
        q-icon(name="layers").q-px-md
        span Materiálové složení
    q-separator
    q-markup-table.q-py-sm(flat separator="none" v-if="mainPart !== undefined && item")
      tbody
        kv(:container="mainContainer" label="Hlavní materiál" :item="mainPart" path="materialType"
          :editor-options="{taxonomy: 'material-type', scope: item.category}" type="taxonomy" :edit="edit")
        kv(:container="mainContainer" label="Vedlejší materiál" :item="mainPart" path="secondaryMaterialTypes"
          :editor-options="{taxonomy: 'material-type'}" type="taxonomy-array" :edit="edit")
        kv(:container="mainContainer" label="Technologie výroby"
          v-if="$taxonomies.relevantTaxonomies[item.category].includes('fabrication-technology')"
          :editor-options="{taxonomy: 'fabrication-technology', scope: item.category}"
          :item="mainPart" path="fabricationTechnology" type="taxonomy-array" :edit="edit")
        kv(:container="mainContainer" label="Barva" :item="mainPart" path="color"
          v-if="$taxonomies.relevantTaxonomies[item.category].includes('color')"
          :editor-options="{taxonomy: 'color', scope: item.category}" type="taxonomy-array" :edit="edit")
  q-card-section.q-gutter-md
    .text-h6.row.justify-between
      .col-auto
        q-icon(name="developer_board").q-px-md
        span Dílčí součásti
      .col-auto
        q-btn(v-if="(item.parts || []).length > 0" color="secondary" outline @click="createNewObjectPart" icon="add") Přidat
    q-separator
    q-list
      object-part-card(:part="part" v-for="(part, idx) in (this.item.parts || [])" :key="idx" :partIndex="idx")
    div(v-if="(secondaryParts || []).length === 0")
      .row.justify-center.text-weight-light
        .col-8.text-h4.text-center
            q-icon(name="widgets" color="secondary")
        .col-8.text-h7.text-center
            span Předmět zatím nemá žádné dílčí součásti
      .row.justify-center
        .q-my-md.col-8.text-center
          q-btn(color="primary" outline @click="createNewObjectPart" icon="add") Přidat součást
</template>

<script>
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { NewObjectPartMixin } from '../editor/new-object-part-mixin'
import { EditMixin } from './edit_mixin'
import ObjectPartCard from 'components/restorations/object/ObjectPartCard.vue'
import KVPair from 'components/KVPair.vue'

export default @Component({
  props: {
    collectionCode: String,
    itemId: [String, Number]
  },
  components: {
    'kv': KVPair,
    'object-part-card': ObjectPartCard
  }
})
class MaterialsPage extends mixins(NewObjectPartMixin, EditMixin) {
  edit = false

  get mainContainer () {
    return `/parts/${this.mainPartIndex}`
  }

  get mainPart () {
    return this.item.parts.find(part => {
      return part.main === true
    })
  }

  get secondaryParts () {
    if (this.item) {
      return this.item.parts.filter(part => {
        return part.main !== true || part.main === undefined
      })
    }
    return undefined
  }

  get mainPartIndex () {
    if (this.item) {
      return this.item.parts.findIndex(part => {
        return part.main === true
      })
    }
    return 0
  }
}
</script>

<style scoped lang="stylus">

</style>
